<div class="row">
	<div class="col-1 col-md-6 mb-4">
		<div class="card">
			<div class="card-header d-flex justify-start items-center gap-2">
				<h2>Consulta de precios de Venta</h2>
			</div>
			<div class="card-body">
				<p class="muted">
					<i class="fa fa-circle-info"></i> Mira, modifica las listas de precios y los costos
				</p>
				<app-price-list-modal [editCost]="true"></app-price-list-modal>
			</div>
		</div>
	</div>
	<div class="col-1 col-md-6 mb-4">
		<div class="card">
			<div class="card-header">
				<h1>Productos sin Costo
					<button tooltip="Guardar todo" class="btn btn-success" (click)="saveAll()" *ngIf="isWaiting() != 0 && saving != isWaiting()">
						<i class="fa fa-save" *ngIf="saving == 0"></i>
						<app-loading-animation *ngIf="saving != 0 && saving != isWaiting()" [height]="'1rem'" [color]="'white'"></app-loading-animation>
					</button>
				</h1>
			</div>
			<div class="card-body">
				<div>
					<div class="row" id="options-other-filters">
						<div class="col-sm form-group">
							<label for="filterVendors" class="form-label">Filtrar</label>
							<div class="input-group input-group-sm">
								<input
									type="text"
									id="filter"
									[(ngModel)]="filterWord"
									(input)="onInputChange($event)"
									placeholder="Filtra por nombre de producto, codigo."
									name="filter"
									class="form-control"
								/>
								<button class="btn btn-primary" (click)="searching()">
									<i class="fa fa-search"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="table-response" style="margin: 0;">
					<table class="table" style="margin: 0;">
						<thead>
							<tr>
								<th>Producto</th>
								<th>Bodega</th>
								<th>Costo</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let p of paginationProductsWithoutCost.filter">
								<td>
									<div class="field">
										<span class="val-span" style="font-size: 0.8em;">
											{{p.productName}}
										</span>
										<span class="field-span">
											<i class="fa-solid fa-key"></i><b>{{p.productCode}}</b>
											<i style="margin-left: 1rem;" class="fa-solid fa-barcode"></i>
											<ng-container *ngIf="p.productBarCode">
												<b> {{p.productBarCode}}</b>
											</ng-container>
											<ng-container *ngIf="!p.productBarCode">
												<b> <i class="fa fa-question"></i></b>
											</ng-container>
										</span>
									</div>
								</td>
								<td>
									<div class="field">
										<span class="val-span">
											{{p.warehouseName}}
										</span>
									</div>
								</td>
								<td>
									<div class="input-group" style="max-width: 9rem;">
										<input [disabled]="p.loading" type="text" [(ngModel)]="p.cost"
											name="{{p.productId}}input" id="{{p.productId}}input"
											placeholder="Agrega costo" class="form-control">
										<button [disabled]="p.loading" class="btn btn-success" (click)="updateCost(p)"
											*ngIf="p.cost && p.cost > 0">
											<i class="fa fa-save" *ngIf="!p.loading"></i>
											<app-loading-animation *ngIf="p.loading" [height]="'1rem'"
												[color]="'white'"></app-loading-animation>
										</button>
									</div>
								</td>
							</tr>
							<tr class="tr-middle" *ngIf="paginationProductsWithoutCost.filter && paginationProductsWithoutCost.filter.length == 0 && !loadingProducts">
								<td colspan="3">
									<p class="display-6 text-muted">
										<i class="fa fa-circle-info"></i>
										No hay productos sin costo
									</p>
								</td>
							</tr>
							<tr class="tr-middle" *ngIf="loadingProducts">
								<td colspan="3">
									<app-loading-animation [height]="'5rem'"></app-loading-animation>
									<p class="display-6">Cargando</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="paginationProductsWithoutCost"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>